import type { PouchDocument, QuoteDocument } from 'paintscout'
import type { Contact } from '@paintscout/api'
import { removeAuth0Prefix } from '../../../users/removeAuth0Prefix/removeAuth0Prefix'

/**
 * Check if a user is assigned to the document
 *
 * A stored document keeps `assignedUsers` as a map of id to `{ assigned }`. A search result keeps
 * it as an array of the assigned ids (the Elasticsearch index docs), so list rows built from search
 * results pass the array form.
 */
export const isUserAssigned = (
  doc: PouchDocument | Partial<QuoteDocument> | Partial<Contact>,
  userId: string
): boolean => {
  const assignedUsers: unknown = doc?.assignedUsers
  if (!assignedUsers) {
    return false
  }

  const id = removeAuth0Prefix(userId)

  if (Array.isArray(assignedUsers)) {
    return assignedUsers.includes(id)
  }

  return !!(assignedUsers as Record<string, { assigned?: boolean }>)[id]?.assigned
}
